import { useState } from "react"
import React from "react"
import { Link } from 'react-router-dom'
import menu from '../../assets/menu.svg'
import close from '../../assets/close.svg'
import MenuList from '../MenuList/MenuList'
import UserMenu from '../MenuList/UserMenu'
import { FaUser } from 'react-icons/fa'


const NavBar = () => {
 const [toggle, setToggle] = useState(false)
 const token= localStorage.getItem('token')
 const rol= localStorage.getItem('rol')


    return (
        <nav className="bg-background_home h-20 w-screen flex items-center justify-between px-10  shadow-slate-400 shadow-md">
         
            <Link to='/'>
              <h1 className="text-[28px]  text-white font-bold">Dra. M Weed</h1>
            </Link>
         

           <div className="flex flex-row gap-4 items-center justify-center">
            <ul 
            className="hidden sm:flex flex-row justify-end items-center 
            gap-8 font-actor text-white text-[16px]">
               
              
               <MenuList />

               <li className="text-xs">
               <Link to='/formularios'>
                  FORMULARIOS 
                </Link> 
               </li>
               

               <li className="text-xs">
               <Link to='/about'>
                   SOBRE NOSOTROS 
                </Link> 
               </li>        
                       
               {!token && <li className="text-xs">
               <Link to='/login'>
                  INICIAR SESION
                </Link> 
               </li> }       
                 
            </ul>
            
            <div className='sm:hidden flex flex-1 justify-end items-center'> 
                 <img src={toggle ? close : menu} alt="menu"
                  className='w-[28px] h-[28px] object-contain'
                  onClick={ () => setToggle((prev) => !prev)}
                  /> 
                  </div>

                  <div className={`${toggle ? 'flex' : 'hidden'} p-6 bg-background_home 
                 absolute top-20 right-4 mx-4 my-2 min-w-[140px] text-white flex-col rounded-xl sidebar`}
                 >
                   <ul>
               <li className="text-xs">
                <Link to='/misturnos'>
                   MIS TURNOS 
                </Link>
               </li>
               <li className="text-xs">
                <Link to='/turnero'>
                   SACAR TURNOS 
                </Link>
               </li>

               <li className="text-xs">
               <Link to='/formularios'>
                   FORMULARIOS 
                </Link> 
               </li>
               
               {/* <li className="text-xs">
               <Link to='/blog'>
                   BLOG 
                </Link> 
               </li>
 */}
               <li className="text-xs">
               <Link to='/about'>
                   SOBRE NOSOTROS 
                </Link> 
               </li>        
                       
               {!token && <li className="text-xs">
               <Link to='/login'>
                  INICIAR SESION
                </Link> 
               </li>}        
               </ul>
            </div>
            {
               token &&
               <UserMenu />
            }
            
           </div>
       
       
        </nav>
    )
}


export default NavBar




